import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import "./App.css";

import BannerAnnouncement from "./components/BannerAnnouncement/BannerAnnouncement";
import HeaderNav from "./components/HeaderNav/HeaderNav.js";
import About from "./components/About/About.js";
import GalleryContainer from "./components/Gallery/GalleryContainer.js";
import Contact from "./components/Contact/Contact.js";

function App() {
  const [hideMessage, setHideMessage] = useState(true)

  // remove annoucement banner after...
  useEffect(() => {
    const today = new Date();
    const cutoff = new Date('08/10/2026');
    if (today < cutoff) {
      setHideMessage(false);
    } else {
      // console.log('cutoff date for banner has passed!')
    }
  },[])

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#869581',  // affects tabs, buttons, etc.
          colorText: '#869581',     // general text
        }
      }}
    >
      <HeaderNav />
      {!hideMessage &&
        <BannerAnnouncement 
          message="Join me in Loveland, CO for Sculpture in the Park - August 7-9, 2026"
          url="https://www.sculptureinthepark.org/candace-greenburg"
          setHideMessage={setHideMessage}
        />
      }
      <div className="flex justify-center items-start min-h-[90vh]">
        <Routes>
          <Route path="/" element={<About />} />
          <Route path="/gallery" element={<GalleryContainer />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </ConfigProvider>
  );
}

export default App;
